import createIcon from '../../createIcon';

/**
 * @component @name Cottage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNEw2IDguNThWN0g0VjEwLjExTDEgMTIuNEwyLjIxIDEzLjk5TDQgMTIuNjJWMjJIMTFWMTZIMTNWMjJIMjBWMTIuNjJMMjEuNzkgMTMuOThMMjMgMTIuNEwxMiA0Wk0xMCAyQzEwIDMuNjYgOC42NiA1IDcgNUM2LjQ1IDUgNiA1LjQ1IDYgNkg0QzQgNC4zNCA1LjM0IDMgNyAzQzcuNTUgMyA4IDIuNTUgOCAySDEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Cottage = createIcon('Cottage', [
  [
    'path',
    {
      d: 'M12 4L6 8.58V7H4V10.11L1 12.4L2.21 13.99L4 12.62V22H11V16H13V22H20V12.62L21.79 13.98L23 12.4L12 4ZM10 2C10 3.66 8.66 5 7 5C6.45 5 6 5.45 6 6H4C4 4.34 5.34 3 7 3C7.55 3 8 2.55 8 2H10Z',
      key: '1uuh6',
    },
  ],
]);

export default Cottage;
